import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AmplifyService } from './amplify.service';
import { DynamoDbService } from './dynamodb.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  #amplify = inject(AmplifyService);
  #ddb = inject(DynamoDbService);
  #router = inject(Router);
  constructor() { }

  canActivate(): Observable<boolean> {
    return this.#amplify.fetchAuthSession.pipe(
      map(credentials => {
        this.#ddb.credentials = credentials;
        if (credentials && credentials.accessKeyId) {
          return true;
        } else {
          console.error('No valid credentials found. Redirecting to login.');
          this.#router.navigate(['/signin']);
          return false;
        }
      }),
      catchError(err => {
        console.error('Error during authentication:', err.message);
        this.#router.navigate(['/signin']);
        return of(false);
      })
    );
  }
}
